<template>
  <el-container class="hp-100">
    <el-main class="hp-100 bgimg">
      <div class="login hp-100">
        <div class="new_login_flex">
          <div class="login_con">
            <div class="row_cl">
              <div class="img">
                <el-image :src="logoUrl" />
              </div>
              <h1 style="font-weight: 500">菁锐人才招聘系统</h1>
            </div>
            <el-form :inline="true" label-width="78px" label-position="left" ref="ruleForm">
              <el-form-item label="用户名：" prop="mobile">
                <el-input placeholder="请输入手机号/英文名" v-model="form.mobile" />
              </el-form-item>

              <!-- <el-form-item label="密码：">
                <el-input show-password placeholder="请输入密码" v-model="form.password" />
              </el-form-item> -->
              <el-form-item label="验证码：" prop="smsCode">
                <div class="bind_code">
                  <el-input
                    type="text"
                    placeholder="请输入验证码"
                    v-model="form.smsCode"
                    class="login-input"
                    @keyup.enter.native="onSubmit"
                  >
                  </el-input>
                  <el-button
                    type="primary"
                    plain
                    @click.native.prevent="bindforgetSendCode"
                    class="codebtn"
                    :disabled="disabled"
                  >
                    {{ btnText }}
                  </el-button>
                </div>
              </el-form-item>
              <el-button
                :class="!form.smsCode ? 'color2' : ''"
                @click="onSubmit"
                type="primary"
                style="width: 310px; border-radius: 4px"
                :disabled="!form.smsCode"
                >登录</el-button
              >
            </el-form>
          </div>
          <div class="new_login_flex_rigjt" style="margin-left: 160px">
            <el-image :src="url" />
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { login, getSms } from '@/api/login'
export default {
  name: 'Login',
  data() {
    return {
      disabled: false,
      btnText: '获取验证码',
      logoUrl:
        'https://elitego-csj-1300257084.cos.ap-shanghai.myqcloud.com/elite/%E7%94%BB%E6%9D%BF.png',
      url: 'https://elitego-csj-1300257084.cos.ap-shanghai.myqcloud.com/elite/%E6%8F%92%E7%94%BB%281%29.png',
      form: {
        smsCode: '', // 验证码
        mobile: '' // 账号
        // password: '' //密码
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 18, message: '请输入密码', trigger: 'blur' }
        ],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
      // form: {
      //   mobile: '', // 账号
      //   password: '' //密码
      // }
    }
  },
  methods: {
    //发送验证码
    bindforgetSendCode() {
      this.$refs['ruleForm'].validateField('mobile', (errorMessage) => {
        if (!errorMessage) {
          getSms({ mobile: this.form.mobile }).then((res) => {
            if (res.data.resultCode === 200) {
              this.disabled = true
              this.btnText = '请稍候...'
              setTimeout(() => {
                this.doloop(60)
              }, 500)
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          this.$message.error('请输入正确的手机号！')
          return false
        }
      })
    },
    //验证码倒计时
    doloop(seconds) {
      seconds = seconds ? seconds : 60
      this.btnText = seconds + 's后获取'
      let countdown = setInterval(() => {
        if (seconds > 0) {
          this.btnText = seconds + 's后获取'
          --seconds
        } else {
          this.btnText = '获取验证码'
          this.disabled = false
          clearInterval(countdown)
        }
      }, 1000)
    },
    async onSubmit() {
      // if (!this.form.smsCode) {
      //   this.$message.warning('请先输入验证码')
      //   returns
      // }
      const res = await login(this.form)
      if (res.data.resultCode === 200) {
        this.$message.success('登录成功')
        const token = res.headers.token
        sessionStorage.setItem('token', token)
        sessionStorage.setItem('userId', res.data.data.id)
        sessionStorage.setItem('userName', res.data.data.userName)
        sessionStorage.setItem('image', res.data.data.userAvatarKey)
        sessionStorage.setItem('mobile', res.data.data.mobile)
        sessionStorage.setItem('menuTree', JSON.stringify(res.data.data.actions))
        sessionStorage.setItem('roleId', res.data.data.roleId)
        sessionStorage.setItem('nameEnglish', res.data.data.nameEnglish)
        // 职位0->部门经理；1->客户经理；2->项目经理；3->商务经理
        sessionStorage.setItem('position', res.data.data.position)

        this.$router.replace({
          path: '/'
        })
      } else {
        this.$messageError(res.data.message)
      }
    }
  }
}
</script>

<style lang="less" scope>
.el-container {
  /deep/ .el-image__inner {
    display: block;
    width: 40px !important;
    height: 46px !important;
  }
  .row_cl {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .img {
      width: 40px;
      height: 46px;
      margin-right: 12px;
    }
  }
  .new_login_flex {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .bgimg {
    background: url('../../../../static/images/left.png') no-repeat left;
    padding: 30px !important;
    position: relative;
    .el-form-item {
      margin-right: 0 !important;
    }

    .el-form-item__content {
      width: 310px !important;
    }
  }
  .el-main {
    .login {
      &_con {
        width: 346px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        h1 {
          margin: 50px 0;
          text-align: center;
          color: #17757a;
          font-weight: 500;
          font-size: 36px;
          font-family: 'PingFang SC';
        }
        h3 {
          color: #3370ff;
          font-size: 22px;
          margin-bottom: 20px;
        }
      }
      .bind_code {
        position: relative;
        .codebtn {
          position: absolute;
          right: 6px;
          font-size: 12px;
          height: 30px;
          line-height: 6px;
          top: 5px;
          width: 70px;
          border: 1px solid #ffffff;

          display: flex;
          justify-content: center;
        }
      }
    }
  }
}
.color2 {
  opacity: 0.7 !important;
}
</style>
